import { render, staticRenderFns } from "./ShowCard.vue?vue&type=template&id=aff107fa&scoped=true&"
import script from "./ShowCard.vue?vue&type=script&lang=js&"
export * from "./ShowCard.vue?vue&type=script&lang=js&"
import style0 from "./ShowCard.vue?vue&type=style&index=0&id=aff107fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aff107fa",
  null
  
)

export default component.exports